import { action, observable, makeObservable } from 'mobx';

const DEFAULT_CONFIG = {
    frequency: 'weekly',
    recipients: '',
    durationInDays: '7',
    deliveryDate: '1',
    targetGroupId: ''
};

export interface IScheduledConfig {
    frequency: string;
    recipients: string;
    durationInDays: string;
    deliveryDate: string;
    targetGroupId: null | string;
    organizationId: null | string;
    sourceName?: null | string;
    excludedContent: string[];
}

export interface IScheduledReport {
    id?: string;
    name: string;
    format: string;
    type: string;
    config: IScheduledConfig;
    organizationId: null | string;
    createdOn?: Date | null;
    updatedOn?: Date | null;
}

export default class ScheduledReportStore {
    report: IScheduledReport = {
        name: '',
        type: '',
        format: 'pdf',
        config: DEFAULT_CONFIG
    };

    constructor(report: IScheduledReport) {
        makeObservable(this, {
            report: observable,
            update: action
        });

        this.update(report);
    }

    update(report: IScheduledReport): void {
        this.report = {
            ...this.report,
            ...report
        };
    }
}
